
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Anders als von Pharmafirmen und Matratzenherstellern suggeriert, ist der achtstündige ununterbrochene Schlaf kein Naturgesetz. Nächtliches Aufwachen ist vielmehr ein ganz normales Phänomen und nicht krankhaft. `}<M mdxType="M">{`Bis zu 10-mal pro Stunde erwachen wir für einige Sekunden, bis zu 23-mal pro Nacht sind wir länger als eine Minute wach – ohne etwas davon zu bemerken.`}</M>{` Erst wenn die Wachphase länger als fünf Minuten anhält, wird der Mensch sich dessen bewusst. Dies passiert etwa ein- bis viermal pro Nacht. Wer noch häufiger fünf Minuten oder länger wach liegt, empfindet seinen Schlaf als gestört.`}</p>
    <p>{`In diesen kurzen Phasen überprüfen wir, ob die Welt um uns herum noch in Ordnung ist und wir beruhigt weiterschlafen können. Dieser Sicherheitsmodus ist in der heutigen Zeit kaum mehr nötig. Und doch hält er sich hartnäckig – wohl seit der Steinzeit. Damals war Wachsamkeit unverzichtbar. Misstrauen und Ängste führten dazu, dass der Mensch überlebte.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;